// src/components/form/pessoa/EnderecoForm.js
import React, { useState, useRef, useEffect } from 'react';
import Input from '../../input/Input';
import CidadeSearch from '../../../pages/geral/CidadeSearch';
import { useCidades } from '../../../contexts/geral/CidadeContext';
import { CidadeCepProvider, useCidadeCep } from '../../../contexts/geral/CidadeCepContext';
import CidadeCepCad from '../../../pages/geral/CidadeCepCad';
import { normalizarCep } from '../../../models/geral/CidadeCep';


const EnderecoForm = ({ endereco, setEndereco }) => {
    const { consultar } = useCidadeCep();
    const [showCadastroCep, setShowCadastroCep] = useState(false);
    const enderecoAtual = useRef({ endereco, setEndereco });
    const consultaAtual = useRef(0);
    enderecoAtual.current = { endereco, setEndereco };
    useEffect(() => () => { ++consultaAtual.current; }, []);
    const consultarMunicipio = async () => {
        const cep = normalizarCep(endereco?.cep);
        const numeroConsulta = ++consultaAtual.current;
        if (cep.length !== 8) return;
        const enderecoId = endereco?.id;
        try {
            const vinculo = await consultar(cep);
            const atual = enderecoAtual.current;
            if (!vinculo || numeroConsulta !== consultaAtual.current ||
                normalizarCep(atual.endereco?.cep) !== cep || atual.endereco?.id !== enderecoId) return;
            atual.setEndereco({
                ...atual.endereco,
                cidadeId: vinculo.cidadeId,
                cidade: { id: vinculo.cidadeId, nome: vinculo.cidadeNome, uf: vinculo.cidadeUf },
            });
        } catch (_) { }
    };
    const handleChange = (field, value) => {
        if (field === 'cep' || field === 'cidadeId') ++consultaAtual.current;
        setEndereco({ ...endereco, [field]: value });
    };

    const { cidades } = useCidades(); // Ajuste para o contexto correto
    const [showSearchCidade, setShowSearchCidade] = useState(false);
    
        
    const handleSelectCidade = (cidadeSel) => {
        ++consultaAtual.current;
        setEndereco({
            ...endereco,
            cidadeId: cidadeSel.id,
            cidade: cidadeSel, // Preenche o objeto cidade
        });
        
        setShowSearchCidade(false);
    };
    
    const handleCidadeExit = (cidadeId) => {
        const cidadeSelecionada = cidades.find(c => c.id.toString() === cidadeId.toString());
        if (cidadeSelecionada) {
            setEndereco({
                ...endereco,
                cidadeId: cidadeSelecionada.id,
                cidade: cidadeSelecionada, // Preenche o objeto cidade
            });
        } else {
            setEndereco({
                ...endereco,
                cidadeId: null,
                cidade: null, // Limpa caso a cidade não seja encontrada
            });
        }
    };

    return (
        
        <div className="section">            
            <h5>Endereço</h5>
            <div className="input-group">
                <Input
                    label="Logradouro"
                    value={endereco?.logradouro || ''}
                    onChange={(e) => handleChange('logradouro', e.target.value)}
                    size={300}
                />
                <Input
                    label="Número"
                    value={endereco?.numero || ''}
                    onChange={(e) => handleChange('numero', e.target.value)}
                    size={100}
                />
            </div>
            <div className="input-group">
                <Input
                    label="Bairro"
                    value={endereco?.bairro || ''}
                    onChange={(e) => handleChange('bairro', e.target.value)}
                    size={300}
                />
                <Input
                    label="Complemento"
                    value={endereco?.complemento || ''}
                    onChange={(e) => handleChange('complemento', e.target.value)}
                    size={300}
                />
            </div>
            <div className="input-group">
                <Input
                    label="CEP"
                    value={endereco?.cep || ''}
                    onChange={(e) => handleChange('cep', e.target.value)}
                    size={100}
                    mask="99999-999"
                    onBlur={consultarMunicipio}
                    btnAdd={() => setShowCadastroCep(true)}
                />
                <Input
                    label="Cidade"
                    value={endereco?.cidadeId || ''}
                    onChange={(e) => handleChange('cidadeId', e.target.value)}
                    btnBuscar={() => setShowSearchCidade(true)}
                    onBlur={(e) => handleCidadeExit(e.target.value)}  
                    size={80}
                />
                <Input
                    value={endereco?.cidade?.nome || ''}
                    disabled
                    size={300}
                />
                <Input
                    label="UF"
                    value={endereco?.cidade?.uf || ''}
                    disabled
                    size={35}
                />
            </div>
            <CidadeCepCad show={showCadastroCep} onHide={() => setShowCadastroCep(false)}
                cidadeInicial={endereco?.cidadeId} cepInicial={endereco?.cep} />
            <CidadeSearch
                show={showSearchCidade}
                onHide={() => setShowSearchCidade(false)}
                onSelectCidade={handleSelectCidade}
            />            
        </div>
        
    );
};

const EnderecoComCeps = (props) => <CidadeCepProvider><EnderecoForm {...props} /></CidadeCepProvider>;
export default EnderecoComCeps;
